import React, { useState } from 'react'
import { usePracticeInterviewing } from './PracticeInterviewingProvider'
import { Button } from '~/lib/ui/button'
import usePipeSDK from '@addpipe/react-pipe-media-recorder'
import { useTranslation } from '../../hooks/useTranslation'

const Question = (question, index) => {
  const content = question.question.content
  const {
    saveInterviewResponse,
    current_user,
    eu,
    audioInterview,
    isMobile,
    setShowForm,
    setShowInterview,
    setFormIndex,
    practiceMode,
    setActiveTab,
    getInterviewResponses,
  } = usePracticeInterviewing()
  const id = 'yns-response-id-' + question.question.id
  const [isDisabled, setIsDisabled] = useState(true)
  const [recorder, setRecorder] = useState(null)

  const { t } = useTranslation('Question')

  const { isLoaded } = usePipeSDK((PipeSDK) => {
    if (isLoaded) return
    const payload = JSON.stringify({
      interview_id: question.question.document_id,
      response_id: question.question.id,
      candidate_id: current_user.id,
    })
    const pipeParams = {
      size: { width: 640, height: 390 },
      qualityurl: 'avq/720p.xml',
      accountHash: '279d721a19400c3873908e8241f49f4f',
      eid: eu ? 'dXeplJ' : 'Kq6hjT',
      mrt: 120,
      avrec: !audioInterview ? 1 : null,
      ao: audioInterview ? 1 : null,
      countdowntimer: 5,
      payload: payload,
    }

    PipeSDK.insert(
      'yns-response-id-' + question.question.id,
      pipeParams,
      (pipeRecorder) => {
        setRecorder(pipeRecorder)
        var recorder = PipeSDK.getRecorderById(
          'yns-response-id-' + question.question.id,
        )

        recorder.onUploadDone = (
          // eslint-disable-next-line no-unused-vars
          recorderId,
          // eslint-disable-next-line no-unused-vars
          streamName,
          // eslint-disable-next-line no-unused-vars
          streamDuration,
          // eslint-disable-next-line no-unused-vars
          audioCodec,
          // eslint-disable-next-line no-unused-vars
          videoCodec,
          // eslint-disable-next-line no-unused-vars
          fileType,
          // eslint-disable-next-line no-unused-vars
          audioOnly,
          // eslint-disable-next-line no-unused-vars
          location,
        ) => {
          setIsDisabled(false)
          if (!practiceMode) {
            recorder.remove()
          }
        }
        if (isMobile) {
          recorder.onVideoUploadSuccess = (
            // eslint-disable-next-line no-unused-vars
            recorderId,
            // eslint-disable-next-line no-unused-vars
            filename,
            // eslint-disable-next-line no-unused-vars
            filetype,
            // eslint-disable-next-line no-unused-vars
            videoId,
            // eslint-disable-next-line no-unused-vars
            audioOnly,
            // eslint-disable-next-line no-unused-vars
            location,
          ) => {
            setIsDisabled(false)
            if (!practiceMode) {
              recorder.remove()
            }
          }
        }
      },
    )
  })

  const handleNextQuestion = (document_id) => {
    if (recorder) {
      recorder.remove()
    }
    saveInterviewResponse(document_id)
  }

  const handleBackToForm = () => {
    setShowForm(true)
    setShowInterview(false)
    setFormIndex(0)
    getInterviewResponses(question.question.document_id)
  }

  const handleViewAll = () => {
    setShowForm(false)
    setShowInterview(false)
    setActiveTab('previousPracticeInterviews')
    getInterviewResponses(question.question.document_id)
  }

  return (
    <div key={index}>
      <p className="mb-4">{'Question ' + (question.index + 1)}</p>
      <h2 className="mb-4">{content.customized_interview_question}</h2>
      <div className="flex w-full">
        <div id={id} className="m-auto"></div>
      </div>
      <div className="mt-4 flex justify-center">
        <Button
          id="save_link"
          onClick={() => handleNextQuestion(question.question.document_id)}
          disabled={isDisabled}
        >
          {t('save')}
        </Button>
        <Button
          className="ml-4"
          variant="outline"
          onClick={() => handleBackToForm()}
        >
          {t('back')}
        </Button>
        <Button
          className="ml-4"
          variant="outline"
          onClick={() => handleViewAll()}
        >
          {t('view')}
        </Button>
      </div>
    </div>
  )
}

export default Question
